"use strict";
/**
 * Domain Aggregate Roots for Manulife Insurance Domain.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyAggregate = void 0;
const base_1 = require("./base");
const value_objects_1 = require("./value-objects");
const events_1 = require("./events");
class PolicyAggregate extends base_1.BaseAggregateRoot {
    _customer;
    _productCode;
    _plan;
    _basePremium;
    _sumAssured;
    _term;
    _riders = [];
    constructor(id, customer, productCode, plan, basePremium, sumAssured, term) {
        super(id);
        if (basePremium.amount < 5_000_000) {
            throw new base_1.BaseDomainException(`Base premium ${basePremium.amount.toLocaleString('vi-VN')} VNĐ violates minimum threshold of 5,000,000 VNĐ`);
        }
        this._customer = customer;
        this._productCode = productCode;
        this._plan = plan;
        this._basePremium = basePremium;
        this._sumAssured = sumAssured;
        this._term = term;
        this.addDomainEvent(new events_1.PolicyCreatedEvent(this.id, customer.id, productCode));
    }
    get customer() {
        return this._customer;
    }
    get productCode() {
        return this._productCode;
    }
    get plan() {
        return this._plan;
    }
    get basePremium() {
        return this._basePremium;
    }
    get sumAssured() {
        return this._sumAssured;
    }
    get term() {
        return this._term;
    }
    get riders() {
        return [...this._riders];
    }
    attachRider(rider) {
        if (this._riders.some((r) => r.riderId === rider.riderId)) {
            throw new base_1.BaseDomainException(`Rider with ID '${rider.riderId}' is already attached to policy`);
        }
        this._riders.push(rider);
    }
    calculateTotalAnnualPremium() {
        let total = this._basePremium.amount;
        for (const rider of this._riders) {
            total += rider.annualPremium.amount;
        }
        this.addDomainEvent(new events_1.PremiumCalculatedEvent(this.id, total));
        return new value_objects_1.Money(total);
    }
    calculateTotalProjectedPremium() {
        const annual = this.calculateTotalAnnualPremium();
        return annual.multiply(this._term.years);
    }
}
exports.PolicyAggregate = PolicyAggregate;
